const getNestedValue = (obj, path) => {
  // Divide el prefijo en claves y recorre el objeto
  return path.split('.').reduce((current, key) => current?.[key], obj);
};

const VariableCard = ({ variable, register, index, prefix, watch, unit, errors }) => {
  //se pasa el objeto errors y ademas el prefijo 'sondas.0.variables o variablesNoSonda'
  //y la funcion retorna si existe o no ese array (ej: errors[sonda][0][variables]) 
  const errorValue = getNestedValue(errors, prefix);
  
  return (
    <div className="w-full border rounded-lg p-4 bg-white shadow-md">
      <div className="flex w-full items-center gap-3 mb-4">
        {/* Checkbox para seleccionar la medida */}
        <input
          type="checkbox"
          {...register(`${prefix}.${index}.isSelected`)}
          className="h-5 w-5 rounded cursor-pointer border-gray-300 text-blue-600 transition-colors duration-200"
        />
        <span className="text-base font-semibold text-gray-800">{variable.label}</span>
      </div>

      {/* Campos de la medida (solo se muestran si el checkbox está marcado) */}
      {watch(`${prefix}.${index}.isSelected`) && (
        <div className="mt-4 space-y-6">
          <div className="p-4 bg-gray-50 rounded-lg border border-gray-100">
            <h3 className="text-sm font-medium text-gray-700 mb-4">Medición del sensor</h3>
            <div className="space-y-4">
              <div>
                <span className="block text-sm font-medium text-gray-600 mb-1.5">
                  Límite máximo ({unit})
                </span>
                <input id={`${prefix}.${index}.maxLimit`}
                  type="number"
                  {...register(`${prefix}.${index}.maxLimit`, {
                    required: {
                      value: true,
                      message: 'Límite máximo es requerido'
                    }
                  })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                />
                {errorValue?.[index]?.maxLimit && (
                  <span className="text-sm text-red-500 mt-1 block">
                    {errorValue[index].maxLimit.message}
                  </span>
                )}
              </div>
              <div>
                <span className="block text-sm font-medium text-gray-600 mb-1.5">
                  Límite mínimo ({unit})
                </span>
                <input id={`${prefix}.${index}.minLimit`}
                  type="number"
                  {...register(`${prefix}.${index}.minLimit`, {
                    required: {
                      value: true,
                      message: 'Límite mínimo es requerido'
                    }
                  })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                />
                {errorValue?.[index]?.minLimit && (
                  <span className="text-sm text-red-500 mt-1 block">
                    {errorValue[index].minLimit.message}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="p-4 bg-gray-50 rounded-lg border border-gray-100">
            <h3 className="text-sm font-medium text-gray-700 mb-4">Límites para las alertas</h3>
            <div className="space-y-4">
              <div>
                <span className="block text-sm font-medium text-gray-600 mb-1.5">
                  Valor máximo ({unit})
                </span>
                <input id={`${prefix}.${index}.maxValue`}
                  type="number"
                  {...register(`${prefix}.${index}.maxValue`, {
                    required: {
                      value: true,
                      message: 'Valor máximo es requerido'
                    }
                  })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                />
                {errors?.[prefix.split('.')]?.[index]?.maxValue && (
                  <span className="text-sm text-red-500 mt-1 block">
                    {errors[prefix.split('.')][index].maxValue.message}
                  </span>
                )}
                {errorValue?.[index]?.maxValue && (
                  <span className="text-sm text-red-500 mt-1 block">
                    {errorValue[index].maxValue.message}
                  </span>
                )}
              </div>
              <div>
                <span className="block text-sm font-medium text-gray-600 mb-1.5">
                  Valor mínimo ({unit})
                </span>
                <input id={`${prefix}.${index}.minValue`}
                  type="number"
                  {...register(`${prefix}.${index}.minValue`, {
                    required: {
                      value: true,
                      message: 'Valor mínimo es requerido'
                    }
                  })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                />
                {errorValue?.[index]?.minValue && (
                  <span className="text-sm text-red-500 mt-1 block">
                    {errorValue[index].minValue.message}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VariableCard;